<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">负氧离子监测设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备名称" prop="DeviceName">
                <el-input
                  v-model="data.DeviceName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备编号" prop="JsonExtend.DeviceNo">
                <el-input
                  v-model="data.JsonExtend.DeviceNo"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="区域" prop="RegionId">
                <el-select
                  v-model="data.RegionId"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in EqRegionArr"
                    :key="item.RegionId"
                    :label="item.RegionName"
                    :value="item.RegionId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="IP地址" prop="JsonExtend.Ip">
                <el-input
                  v-model="data.JsonExtend.Ip"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="端口号" prop="JsonExtend.Port">
                <el-input
                  v-model="data.JsonExtend.Port"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input
                  v-model="data.Longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input
                  v-model="data.Latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "WeatherEquipmentInfo",
  controller: "UI",
  action: "WeatherEquipmentInfo",
  data() {
    return {
      data: {
        RegionId: "",
        Latitude: "",
        Longitude: "",
        IsOnline: "",
        JsonExtend: {
          DeviceNo: null,
          NearBy: null,
          Ip: null,
          Port: 0,
          UserName: null,
          Password: null,
          Rtsp: null,
          IndexCode: null,
          EquipModel: null,
          WarrantyPeriod: null,
          CustomType: null,
          Position: null,
          Name: null,
          LinkPhone: null,
          ManagementUnit: null,
          Introduction: null,
          IsShowPosition: null,
          FileId: null,
          PersonNum: 0,
          Status: 0,
        },
      },
      EqRegionArr: [],
      EqStatusArr: [
        { value: true, label: "开放" },
        { value: false, label: "关闭" },
      ],
      IsEdit: false,
      rules: {
        DeviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        "JsonExtend.DeviceNo": [
          { required: true, message: "请输入设备编号", trigger: "blur" },
        ],
        RegionId: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        "JsonExtend.Port": [
          {
            required: false,
            message: "请输入有效的端口号",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        Longitude: [
          {
            required: false,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        Latitude: [
          {
            required: false,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
      },
      loading: false,
      loadingText: "加载中..."
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    //区域
    this.getRegionInfo();
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionApi()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        new MyApis.TranResourcesApi()
          .GetEquipmentById({ deviceId: InfoId })
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
            this.data.JsonExtend = JSON.parse(this.data.JsonExtend);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.data.RegionId != null && this.data.RegionId != "") {
        const RegionName = this.EqRegionArr.filter((item) => {
          return item.RegionId === this.data.RegionId;
        });
        this.data.RegionName = RegionName[0].RegionName;
      }
      this.data.JsonExtend = JSON.stringify(this.data.JsonExtend);
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "负氧离子监测设备信息修改";
            this.logInfo.LogMessage = r
              ? "负氧离子监测设备信息修改成功"
              : "负氧离子监测设备信息修改失败";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "负氧离子监测设备详情";
            this.addOperationLog();
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          DeviceId: uuid,
          Validity: 1, //新增编辑是1，删除是0
          IsOnline:false,//默认离线
          EquipmentType: "Weather",
          DeviceType: "Weather",
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "负氧离子监测设备信息添加";
            this.logInfo.LogMessage = r
              ? "负氧离子监测设备信息添加成功"
              : "负氧离子监测设备信息添加失败";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "负氧离子监测设备详情";
            this.addOperationLog();
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
